import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import chroma from 'chroma-js';
import { useSearchParams } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';


//components
import MainLayoutV2 from '../../layouts/MainLayoutV2';
import Block from '../../stories/layout-components/Block';
import nodeAxiosFirebase from '../../utils/nodeAxiosFirebase';
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
} from '@mui/material';
import Checkbox from '../../stories/general-components/Checkbox';
import TextField from '../../stories/general-components/TextField';
import { setGeneralStatus } from '../../redux/actions-v2/coreAction';


// Ensure the global flag is initialized once.
if (typeof window.__MAKE_SCRIPT_HAS_RUN_ONCE === 'undefined') {
  window.__MAKE_SCRIPT_HAS_RUN_ONCE = false;
}


const SettingsBridge = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const businessPreference = useSelector((state) => state.core.businessData);
  const [searchParams] = useSearchParams(); // Added to read query parameters

  const [makeScriptLoaded, setMakeScriptLoaded] = useState(false);
  const [makeScriptError, setMakeScriptError] = useState(null);
  const portalContainerRef = useRef(null);

  useEffect(() => {
    if (!document.querySelector('script[src="https://eu1.make.com/portal/static/js/portal-integrations.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://us2.make.com/portal/static/js/portal-integrations.js';
      script.async = true;
      script.type = 'module';
      document.body.appendChild(script);
    }

    const timeout = setTimeout(() => {
      if (portalContainerRef.current) {
        portalContainerRef.current.innerHTML = `
         <portal-integrations urlOrPrefix="https://extensionsext-kjeoh6r3gq-nn.a.run.app/make">
            </portal-integrations>
        `;
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <MainLayoutV2
      icon="SettingsOutlined"
      pageTitle={t('settings')}
      subTitle={t('manageYouBridge')}
    >
      <Block height={1} heightPercentage={98} noBorder>
        {makeScriptError && (
          <Box sx={{ padding: 2, color: 'error.main', textAlign: 'center' }}>
            <p>{t('makeIntegrationError', 'There was an error loading the Make integration:')}</p>
            <p>{makeScriptError}</p>
            <p>{t('makeIntegrationTroubleshooting', 'Please check the browser console for more details and ensure your internet connection and VPN settings allow access to Make.com.')}</p>
          </Box>
        )}


        <div
          ref={portalContainerRef}
          style={{
            width: '1000px',
            height: '90vh',
          }}
        />

        {makeScriptLoaded && !makeScriptError && !businessPreference?.id && (
          <Box sx={{ padding: 2, textAlign: 'center' }}>
            <p>{t('makeIntegrationUserNotIdentified', 'Make integration loaded, but user/business ID is missing.')}</p>
          </Box>
        )}

      </Block>
    </MainLayoutV2>
  );
};

export default SettingsBridge;
